import * as XLSX from "xlsx";

const COLUMN_ALIASES = {
  adviserfullname: "fullName",
  name: "fullName",
  adviseremailaddress: "email",
  emailaddress: "email",
  email: "email",
  adviserid: "ioAdviserId",
  ioadviserid: "ioAdviserId",
  id: "ioAdviserId",
  groupid: "ioGroupId",
  userid: "ioUserId",
};

export const normaliseIOImportHeader = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

export const normaliseIOImportEmail = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase();

export const findIOImportHeader = (rows) => {
  for (let rowIndex = 0; rowIndex < Math.min(rows.length, 20); rowIndex += 1) {
    const columns = {};

    (rows[rowIndex] || []).forEach((value, columnIndex) => {
      const field = COLUMN_ALIASES[normaliseIOImportHeader(value)];
      if (field && columns[field] === undefined) columns[field] = columnIndex;
    });

    if (
      columns.email !== undefined &&
      columns.ioAdviserId !== undefined &&
      columns.ioGroupId !== undefined &&
      columns.ioUserId !== undefined
    ) {
      return { rowIndex, columns };
    }
  }

  return null;
};

export const parseIOImportWorkbook = (arrayBuffer, fileName = "") => {
  if (!/\.(xlsx|xls)$/i.test(String(fileName))) {
    throw new Error("Please choose an .xlsx or .xls file.");
  }

  const workbook = XLSX.read(arrayBuffer, { type: "array", raw: true });

  for (const sheetName of workbook.SheetNames) {
    const sheetRows = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
      header: 1,
      defval: "",
      raw: true,
    });
    const header = findIOImportHeader(sheetRows);
    if (!header) continue;

    const rows = sheetRows
      .slice(header.rowIndex + 1)
      .map((row, index) => ({
        rowNumber: header.rowIndex + index + 2,
        fullName:
          header.columns.fullName === undefined
            ? ""
            : String(row?.[header.columns.fullName] ?? "").trim(),
        email: normaliseIOImportEmail(row?.[header.columns.email]),
        rawIoAdviserId: row?.[header.columns.ioAdviserId],
        rawIoGroupId: row?.[header.columns.ioGroupId],
        rawIoUserId: row?.[header.columns.ioUserId],
      }))
      .filter(
        (row) =>
          row.fullName ||
          row.email ||
          String(row.rawIoAdviserId).trim() ||
          String(row.rawIoGroupId).trim() ||
          String(row.rawIoUserId).trim(),
      );

    return { rows, sheetName };
  }

  throw new Error(
    "The workbook must contain a sheet with email, id, group.id and user.id columns.",
  );
};
